shadow$provide[449] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `varying vec2 vSprite;

vec4 getSample(vec2 xy);

vec4 getSpriteColor() {
  return getSample(vSprite);
}`;

};